import encrypt from '../helpers/encrypt'

const USER = '$2a$14$I08p.4A2aM4KXgttqP9PhOmbHwj8FcgahtZZ03cKdY/fNL/i1CP.C'

class User {
  set (item) {
    const encryptUser = encrypt.encodeUser(item)
    localStorage.setItem(USER, encryptUser)
  }
  get () {
    return localStorage.getItem(USER) !== null ? JSON.parse(encrypt.decodeUser(localStorage.getItem(USER))) : null
  }
  remove () {
    localStorage.removeItem(USER)
  }
}

export default new User()